import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Main from './components/Main';
import LegalNotice from './components/legalNotice/LegalNotice';
import DataPrivacy from './components/dataPrivacy/DataPrivacy';
import Navigation from './components/navigation/Navigation';
import Footer from './components/footer/Footer';
import CookieConsent from './components/footer/CookieConsent';
import NotFound from './components/notFound/NotFound';
import Accessibility from './components/accessibility/Accessibility';
import StickyFooter from './components/footer/StickyFooter';
import ScrollToLocation from './components/common/ScrollToLocation';

function App() {
  return (
    <>
      <ScrollToLocation />
      <CookieConsent />
      <Navigation />

      <Routes>
        <Route exact path='/' element={<Main />} />
        <Route path='/impressum' element={<LegalNotice />} />
        <Route path='/datenschutz' element={<DataPrivacy />} />
        <Route path='/barrierefreiheit' element={<Accessibility />} />
        <Route path='/404' element={<NotFound />} />
        <Route path='*' element={<NotFound />} />
      </Routes>

      <Footer />
      <StickyFooter />
    </>
  );
}

export default App;
